export function buildMergedAmends({ persistedAmends = [], inheritedAmends = [] } = {}) {
    const persistedKeys = new Set(persistedAmends.map((amend) => amend?.payload?.amendsKey).filter(Boolean))
    return [
        ...persistedAmends,
        ...inheritedAmends
            .filter((amend) => amend?.payload?.amendsKey && !persistedKeys.has(amend.payload.amendsKey))
            .map((amend) => ({ ...amend, _isInherited: true })),
    ]
}
